var _defs, _path, _path2, _g, _path3, _g2, _g3, _g4, _g5, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -3 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hu",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sa",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8c69a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 34 L14 34 L16 40 L52 40 L60 36 L54 50 Q32 54 12 50 L6 44Z",
    fill: "url(#hu)",
    stroke: "#1c0f05",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 34 L4 28 L14 28 L14 34Z",
    fill: "#4a2c12",
    stroke: "#1c0f05",
    strokeWidth: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e0b860"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43,
    width: 3,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43.5,
    width: 3,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 43.5,
    width: 3,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 43,
    width: 3,
    height: 2.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44 Q32 47 55 43",
    stroke: "#c49a5a",
    strokeWidth: 1,
    fill: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a1708",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 40 L22 6 M35 40 L35 3 M47 40 L47 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 36 L63 30",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#5a4630",
    strokeWidth: 0.6,
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6 L4 28 M35 3 L14 30 M35 3 L60 36 M47 10 L62 32"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#sa)",
    stroke: "#8a7a58",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9 Q22 7.5 29 9 Q30.5 15 29 20 Q22 18.5 15 20 Q13.5 15 15 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22 Q22 20.5 30 22 Q31.5 28 30 34 Q22 32.5 14 34 Q12.5 28 14 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 6 Q35 4.5 42 6 Q43.5 12 42 18 Q35 16.5 28 18 Q26.5 12 28 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 20 Q35 18.5 43 20 Q44.5 27 43 34 Q35 32.5 27 34 Q25.5 27 27 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 13 Q47 11.5 53 13 Q54.5 18 53 23 Q47 21.5 41 23 Q39.5 18 41 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 25 Q47 23.5 53 25 Q54.5 30 53 36 Q47 34.5 41 36 Q39.5 30 41 25Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#b3261e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6 L28 4 L22 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 3 L41 1 L35 -1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 10 L53 8 L47 6Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51 Q4 48 8 51 T16 51 T24 51 T32 51 T40 51 T48 51 T56 51 T64 51 L64 58 L0 58Z",
    fill: "#4f86b8",
    opacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51 Q4 48 8 51 T16 51 T24 51 T32 51 T40 51 T48 51 T56 51 T64 51",
    fill: "none",
    stroke: "#dcecf8",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploration);
export default __webpack_public_path__ + "static/media/exploration.6bf78f101c417abadbccd33793a9edb2.svg";
export { ForwardRef as ReactComponent };